import { render, staticRenderFns } from "./ModuleRating.vue?vue&type=template&id=1c380a3a&scoped=true"
import script from "./ModuleRating.vue?vue&type=script&lang=js"
export * from "./ModuleRating.vue?vue&type=script&lang=js"
import style0 from "./ModuleRating.vue?vue&type=style&index=0&id=1c380a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c380a3a",
  null
  
)

export default component.exports